<template>
  <div class="detail" ref="box">
    <div class="detailContainer" v-show="!isDetail">
      <div class="news-container" v-for="(item, index) in newsList" :key="index">
        <div class="title">{{item.Title}}</div>
        <div class="t3">Tags: {{item.Tags}}</div>
        <div class="t3">{{item.Date | formateDate}}</div>
        <div class="news-body">
          <img :src="item.Image" class="img">
          <div class="news">
            <div class="subtitle">{{item.Subtitle}}</div>
            <div class="content" v-html="item.Content"></div>
          </div>
          <div class="pointer read-more" @click="showDetail(item)">{{$t('lang.news.readMore')}}</div>
        </div>
      </div>
    </div>

    <div class="detailContainer" v-show="isDetail">
      <img :src="back" class="pointer back-image" @click="backToList()"/>
      <div class="title">{{newsDetail.Title}}</div>
      <div class="detail-body">
        <div class="subtitle">{{newsDetail.Subtitle}}</div>
        <div class="detail-content" v-html="newsDetail.Content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import logo from '@/assets/images/promotion/promotion2.png'
import back from '@/assets/images/common/back_circle.svg'
import {mapMutations} from 'vuex'

export default {
  name: 'About',
  data () {
    return {
      logo,
      back,
      isDetail: false,
      newsList: [],
      newsDetail: {},
      newsScrollPos: 0
    }
  },
  filters: {
    formateDate (datetime) {
      if (localStorage.locale === 'ZH') {
        const date = datetime.split('T')[0]
        const time = datetime.split('T')[1].split(':')
        return date + ' ' + time[0] + ':' + time[1]
      } else {
        let m = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        let time = new Date(datetime)
        let year = time.getFullYear()
        let month = time.getMonth()
        let day = time.getDate()
        if (day < 10) {
          day = '0' + day
        }
        return day + ' ' + m[month] + ' ' + year
      }
    }
  },
  mounted () {
    this.getNewsList()
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute'
    }),
    showDetail (item) {
      this.isDetail = true
      this.newsDetail = item
      this.newsScrollPos = this.$refs.box.scrollTop
      this.$refs.box.scrollTop = 0
    },
    backToList () {
      let that = this
      this.isDetail = false
      that.$nextTick(function () {
        this.$refs.box.scrollTop = this.newsScrollPos
      })
    },
    /****
     * 2021-11-24 CHP 修改Internation值为internation
     */
    getNewsList () {
      const url = '/innovation/news/getAll'
      const data = {
        // Internation: localStorage.locale
        Internation: this.$store.state.internation
      }
      request('post', url, data).then(res => {
        this.newsList = res
        this.newsList = this.newsList.get(0)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .detail {
    height: 100%;
    overflow: auto;
    padding-right: 10px;
    font-family: Roboto;
    .title {
      font-size: 22px;
      line-height: 26px;
      color: #F6D9AA;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .detailContainer {
      font-family: Roboto;
      font-style: normal;
      height: 100%;
      .t1 {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t2 {
        font-size: 18px;
        line-height: 140%;
        color: #fff;
        margin-bottom: 12px;
      }
      .t3 {
        display: flex;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #c4c4c4;
        margin: 2px 0;
      }
      .news-body {
        position: relative;
        display: flex;
        height: 232px;
        padding-bottom: 58px;
        .img {
          height: calc(100% - 2px);
          flex-shrink:0;
        }
        @media screen and (max-width: 768px) and (min-width:481px) {
          .news {
            margin-left: 15px;
            margin-right: 27px;
            overflow: hidden;
            .subtitle {
              font-style: normal;
              font-weight: 500;
              font-size: 22px;
              line-height: 26px;
              color: #F6D9AA;
            }
            .content {
              font-style: normal;
              font-weight: 300;
              font-size: 14px;
              line-height: 140%;
              color: #FFFFFF;
              height: 100%;
              overflow: hidden;
            }
          }
         .read-more {
            position: absolute;
            margin-left: 20px;
            margin-right: 30px;
            right: 20px;
            bottom: 30px;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color: #F6D9AA;
          }
          .back-image {
            position: absolute;
            left: 40px;
            top: 38px;
          }
          .detail-body {
            margin-right: 20px;
            margin-top: 31px;
            padding: 29px;
            border-radius: 6px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
            background: #3D3D3D;
            .subtitle {
              font-weight: 500;
              font-size: 22px;
              line-height: 26px;
              color: #FFFFFF;
            }
            .detail-content {
              margin-top: 23px;
              color: #C4C4C4;
            }
          }
        }
        @media screen and (min-width:769px) {
          .news {
            margin-left: 20px;
            margin-right: 177px;
            overflow: hidden;
            .subtitle {
              font-style: normal;
              font-weight: 500;
              font-size: 22px;
              line-height: 26px;
              color: #F6D9AA;
            }
            .content {
              font-style: normal;
              font-weight: 300;
              font-size: 14px;
              line-height: 140%;
              color: #FFFFFF;
              height: 100%;
              overflow: hidden;
            }
          }
          .read-more {
            position: absolute;
            margin-left: 20px;
            margin-right: 30px;
            right: 20px;
            bottom: 60px;
            font-weight: 500;
            font-size: 14px;
            line-height: 16px;
            color: #F6D9AA;
          }
          .back-image {
            position: absolute;
            left: 40px;
            top: 38px;
          }
          .detail-body {
            margin-right: 50px;
            margin-top: 31px;
            padding: 29px;
            border-radius: 6px;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
            background: #3D3D3D;
            .subtitle {
              font-weight: 500;
              font-size: 22px;
              line-height: 26px;
              color: #FFFFFF;
            }
            .detail-content {
              margin-top: 23px;
              color: #C4C4C4;
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 3px;
      height: 100%;
    }
    &::-webkit-scrollbar-track {
      width: 3px;
      height: 100%;
      background-color: transparent;
      border-radius: 33px;
    } /* 滚动条的滑轨背景颜色 */
    &::-webkit-scrollbar-thumb {
      width: 3px;
      border-radius: 33px;
      background-color: #F6D9AA;
    } /* 滑块颜色 */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/News.vue